import { FocusedDayService } from '@yarmill/types';
import { useRootStore } from './use-root-store';

export function useFocusedDayService(): FocusedDayService {
  const rootStore = useRootStore();

  return rootStore.focusedDayService;
}
